export default __webpack_public_path__ + "static/media/bonus-test-result-reward.2e885179.mp3";